import React from "react";

type Props = {
  items: string[]; // e.g., ["snowwhite","jasmine","ariel"]
};

/**
 * Renders a compact row of earned badges.
 * Looks in /public/badgeCollection/<slug>.png for the image.
 */
const BadgeCollectionRow: React.FC<Props> = ({ items }) => {
  if (!items || items.length === 0) return null;

  // Title-case helper for alt labels (e.g., "snowwhite" -> "Snowwhite")
  const label = (s: string) =>
    s.replace(/[-_]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <div className="w-full flex justify-center mt-4">
      <div className="flex gap-2 flex-wrap items-center justify-center">
        {items.map((slug) => {
          const src = `/badgeCollection/${slug}.png`;
          return (
            <img
              key={slug}
              src={src}
              alt={`${label(slug)} badge`}
              className="h-10 w-10 rounded-full object-cover border border-gray-200 shadow-sm"
              loading="lazy"
            />
          );
        })}
      </div>
    </div>
  );
};

export default BadgeCollectionRow;
